import { CityTabId } from '../../types';
import { CITY_NAME_TO_TAB_ID } from './constants';
import { RegionalOfficesSectionProps } from './types';

const TRUSTED_YANDEX_MAP_DOMAINS = ['yandex.ru'];

export function isTrustedYandexMapWidgetSrc(url: string): boolean {
    try {
        const parsed = new URL(url);
        const isHttps = parsed.protocol === 'https:';
        const isTrustedHost = TRUSTED_YANDEX_MAP_DOMAINS.some(
            domain => parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`)
        );
        const isMapWidgetPath = parsed.pathname.startsWith('/map-widget/');

        return isHttps && isTrustedHost && isMapWidgetPath;
    } catch {
        return false;
    }
}

export const normalizeCityName = (cityName: string) =>
    cityName.trim().toLowerCase().replace(/ё/g, 'е').replace(/\./g, '').replace(/[—–-]/g, ' ').replace(/\s+/g, ' ');

export const resolveDefaultCityId = (
    userCityName: string,
    offices: RegionalOfficesSectionProps['offices']
): CityTabId => {
    const normalizedUserCityName = normalizeCityName(userCityName);

    if (!normalizedUserCityName) {
        return 'moscow';
    }

    const mappedCityId = CITY_NAME_TO_TAB_ID[normalizedUserCityName];

    if (mappedCityId && offices.some(city => city.id === mappedCityId)) {
        return mappedCityId;
    }

    const officeByLabel = offices.find(city => normalizeCityName(city.label) === normalizedUserCityName);

    return officeByLabel?.id || 'moscow';
};
